import { Component, OnInit } from '@angular/core';

import { Costcenter } from '../costcenter';
import { CostcenterService } from '../costcenter.service';

import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
@Component({
  selector: 'app-costcenter-details',
  templateUrl: './costcenter-details.component.html',
  styleUrls: ['./costcenter-details.component.css']
})
export class CostcenterDetailsComponent implements OnInit {
  costcenter = new Costcenter();
  constructor(
    private costcenterService: CostcenterService,
		private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit() {
    this.GetCostcenterDetails();
  }

  GetCostcenterDetails() {
    const costcenterid = +this.route.snapshot.paramMap.get('costcenterid');
    this.costcenterService.GetCostCenterDetails(costcenterid)
      .subscribe(costcenter =>
       { 
         this.costcenter = costcenter[0]
         console.log(this.costcenter)
       });
  }

 goBack(): void {
   this.location.back();
 }

}
